import firebase from "firebase/compat/app";
import "firebase/compat/functions";

const getFunctions = () => firebase.app().functions();

export async function requestCmrFieldAddition(payload) {
  const callable = getFunctions().httpsCallable("requestCmrFieldAddition");
  const result = await callable(payload);
  return result.data;
}

export async function submitCmrDataFlowRequest(payload) {
  const callable = getFunctions().httpsCallable("submitCmrDataFlowRequest");
  const result = await callable(payload);
  return result.data;
}

export async function reviewCmrDataFlowRequest(payload) {
  const callable = getFunctions().httpsCallable("reviewCmrDataFlowRequest");
  const result = await callable(payload);
  return result.data;
}
